import { render, staticRenderFns } from "./productSalePolicy.vue?vue&type=template&id=bdeea6dc&scoped=true"
import script from "./productSalePolicy.vue?vue&type=script&lang=js"
export * from "./productSalePolicy.vue?vue&type=script&lang=js"
import style0 from "./productSalePolicy.vue?vue&type=style&index=0&id=bdeea6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeea6dc",
  null
  
)

export default component.exports